// extracted by mini-css-extract-plugin
export var root = "_6dzn";
export var rootButtonPrimary = "Efy0";
export var rootButtonSecondary = "STDw";
export var rootButtonWrapper = "AxBu";
export var rootHeading = "_24Db";
export var rootItem = "_4XYS";
export var rootItemText = "uwqx";
export var rootItems = "_7sGd";
export var rootItemsWrapper = "NCwZ";
export var rootSubheading = "_8tio";